<template>
  <round-dates
    :start-date="{
      datetime: scoreSet.galleryStartDate,
      timezone: scoreSet.galleryStartTimezone
    }"
    :end-date="{
      datetime: scoreSet.galleryEndDate,
      timezone: scoreSet.galleryEndTimezone
    }"
    @updated="onUpdated"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import RoundDates from '@/lib/components/Rounds/RoundDates';

export default {
  inject: ['lang'],
  components: {
    RoundDates
  },
  data() {
    return {
      map: {
        start: {
          datetime: 'galleryStartDate',
          timezone: 'galleryStartTimezone'
        },
        end: {
          datetime: 'galleryEndDate',
          timezone: 'galleryEndTimezone'
        }
      }
    };
  },
  computed: {
    ...mapGetters('judgingFastStart', ['scoreSet'])
  },
  methods: {
    ...mapMutations('judgingFastStart', ['setScoreSet']),
    onUpdated(property, date) {
      if (this.map[property]) {
        this.setScoreSet({
          ...this.scoreSet,
          [this.map[property]['datetime']]: date.datetime,
          [this.map[property]['timezone']]: date.timezone
        });
      }
    }
  }
};
</script>
